import { render, staticRenderFns } from "./directPayment.vue?vue&type=template&id=563b170d&scoped=true&"
import script from "./directPayment.vue?vue&type=script&lang=js&"
export * from "./directPayment.vue?vue&type=script&lang=js&"
import style0 from "./directPayment.vue?vue&type=style&index=0&id=563b170d&prod&lang=scss&scoped=true&"
import style1 from "./directPayment.vue?vue&type=style&index=1&id=563b170d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b170d",
  null
  
)

export default component.exports